import Vue from "vue";
import "bootstrap";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/app.scss";
import Paginate from "vuejs-paginate";
import BootstrapVue from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("paginate", Paginate);
Vue.component("datepicker", Datepicker);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
